export async function copy(text) {
	return navigator.clipboard
		? navigator.clipboard.writeText(text)
		: copyFallback(text);
}

async function copyFallback(text) {
	var textArea = document.createElement("textarea");
	textArea.value = text;

	// Avoid scrolling to bottom
	textArea.style.top = "0";
	textArea.style.left = "0";
	textArea.style.position = "fixed";

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		document.execCommand("copy");
	} catch (err) {
		throw err;
	} finally {
		document.body.removeChild(textArea);
	}
}
